export default __webpack_public_path__ + "static/media/big-group-trees.7285a8d8.svg";